import {
  Box,
  Grid,
  LinearProgress,
  linearProgressClasses,
  LinearProgressProps,
  styled,
  Typography
} from '@mui/material';
import DataTableGrid from '../DataTableGrid';
import { DEGRADED_STATE_ICON, GOOD_STATE_ICON, ModalTable } from '../ModalTable';
import { GridColDef, GridRowParams } from '@mui/x-data-grid';
import { useState } from 'react';
import { EpSessions } from '../Dashboards/ApplicationHighlightsDashboard';

const columns: GridColDef[] = [
  {
    field: 'performance',
    headerName: 'Performance',
    width: 100,
    renderCell: (params) => {
      return <img src={params.value === 'good' ? GOOD_STATE_ICON : DEGRADED_STATE_ICON} width={24} height={24} />;
    }
  },
  {
    field: 'start_time',
    headerName: 'Start Time',
    width: 300,
  },
  {
    field: 'end_time',
    headerName: 'End Time',
    width: 300,
  },
  {
    field: 'app_name',
    headerName: 'App Name',
    width: 250,
  },
  {
    field: 'src_addr',
    headerName: 'IP-1',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'dst_addr',
    headerName: 'IP-2',
    flex: 1,
    minWidth: 150,
  },
  {
    field: 'src_port',
    headerName: 'IP-1 Port',
    width: 100,
  },
  {
    field: 'dst_port',
    headerName: 'IP-2 Port',
    width: 100,
  },
  {
    field: 'proto',
    headerName: 'Protocol',
    width: 100,
  },
  {
    field: 'tx_bytes',
    headerName: 'IP-1 to IP-2 Bytes',
    width: 160,
  },
  {
    field: 'rx_bytes',
    headerName: 'IP-2 to IP-1 Bytes',
    width: 160,
  },
];

const columnVisible = {
  start_time: true,
  end_time: true,
  src_addr: true,
  src_port: true,
  dst_addr: true,
  dst_port: true,
  proto: true,
  app_name: true,
  tx_bytes: true,
  tx_packets: false,
  rx_bytes: true,
  ep_id: true,
  app_service_id: true,
  node_id: true,
};

interface SessionTableProps {
  percentage: number;
  sessions: EpSessions[];
  title: string;
  fromModal?: boolean;
}

export const SessionTable = ({ percentage, sessions, title, fromModal = false }: SessionTableProps) => {
  const [selectedRow, setSelectedRow] = useState(undefined);
  const [open, setOpen] = useState(false);

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: '#4CAF50',
    },
    [`& .${linearProgressClasses.bar}`]: {
      backgroundColor: '#F44336',
    },
  }));

  function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        width: '30%',
        minWidth: 430,
        top: 760,
        right: 60,
        ...(!fromModal && { position: 'absolute' }),
      }}>
        <Typography sx={{ minWidth: 130 }}>Degraded flows</Typography>
        <Box sx={{
          ...(fromModal ? {
            position: 'relative',
            left: '22px',
          } : {
            position: 'absolute',
            left: '135px',
          }),
          zIndex: 20,
        }}>
          <Typography
            variant="body2"
            sx={{ color: 'white' }}
          >{`${Math.round(props.value)}%`}</Typography>
        </Box>
        <Box sx={{ width: '100%', mr: 1 }}>
          <BorderLinearProgress variant="determinate" {...props} />
        </Box>
      </Box>
    );
  };

  const handleRowClick = (params: GridRowParams) => {
    const { id, ...updatedParams } = params?.row || {};
    setSelectedRow(updatedParams);
    setOpen(true);
  };

  return (
    <>
      <LinearProgressWithLabel value={percentage} color="primary" sx={{ height: 30 }}/>
      <Grid container spacing={5} sx={{ marginTop: 1, minHeight: '300px' }}>
        <Grid item xs={12} md={12}>
          <DataTableGrid
            rows={sessions}
            columns={columns}
            columnVisibilityModel={columnVisible}
            onRowClick={handleRowClick}
            pagination
            pageSize={50}
          />
          {selectedRow && <ModalTable open={open} handleClose={() => setOpen(false)} data={selectedRow} title={title} />}
        </Grid>
      </Grid>
    </>
  );
};